var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'make-the-carbon-theme-go-dark': _vm.model.useDarkMode,
    'make-the-carbon-theme-go-white': !_vm.model.useDarkMode,
  }},[_c('div',{staticClass:"main"},[_c('HeaderBar'),_c('div',{staticStyle:{"padding":"60px 4% 1%"}}),_c('NotificationsView'),_c('Transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[(_vm.model.showResults)?_c('ResultsView'):_c('HomeView')],1)],1),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }